import React from 'react'
import PropTypes from 'prop-types'
import {Flex} from '@chakra-ui/react'
import GallerySwiper from './gallery-swiper'
import {parseAndSanitizeJSON} from '../../../utils/utils'
import YoutubeIframe from '../../youtube-video'

const ProductDetailGallery = ({
    heroImageGroup,
    loadingStrategy = 'lazy',
    openModal,
    videoUrl,
    selectedIndex,
    handleGalleryNavigation,
    swiperRef,
    styles,
    variant,
    setIsModalGallerySwiper,
    setSelectedIndex,
    isModalOpen,
    onBoundaryNavigate,
    subModelIdentifier,
}) => {
    const videos = parseAndSanitizeJSON(videoUrl)?.filter((item) => item?.videolink) || []
    const imageCount = heroImageGroup?.images?.length || 0
    const videoIndex = imageCount
    const video = videos[selectedIndex - imageCount]

    return video && !isModalOpen && selectedIndex === videoIndex ? (
        <Flex
            {...styles.heroImage}
            data-testid="image-gallery-video"
            sx={{justifyContent: 'center', alignItems: 'center'}}
        >
            <Flex {...styles.inGridVideoHero} {...styles.videoHeroGallery}>
                <YoutubeIframe title={video.title} videoSrc={video.videolink} />
            </Flex>
        </Flex>
    ) : (
        <GallerySwiper
            heroImageGroup={heroImageGroup}
            loadingStrategy={loadingStrategy}
            openModal={openModal}
            selectedIndex={selectedIndex}
            styles={styles}
            swiperRef={swiperRef}
            variant={variant}
            handleGalleryNavigation={handleGalleryNavigation}
            setIsModalGallerySwiper={setIsModalGallerySwiper}
            setSelectedIndex={setSelectedIndex}
            subModelIdentifier={subModelIdentifier}
            isModalOpen={isModalOpen}
            onBoundaryNavigate={onBoundaryNavigate}
        />
    )
}

ProductDetailGallery.propTypes = {
    heroImageGroup: PropTypes.object,
    loadingStrategy: PropTypes.string,
    openModal: PropTypes.func,
    videoUrl: PropTypes.string,
    selectedIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    swiperRef: PropTypes.object,
    styles: PropTypes.object,
    variant: PropTypes.string,
    handleGalleryNavigation: PropTypes.func,
    setIsModalGallerySwiper: PropTypes.func,
    setSelectedIndex: PropTypes.func,
    isModalOpen: PropTypes.bool,
    onBoundaryNavigate: PropTypes.func,
    subModelIdentifier: PropTypes.string,
}

export default ProductDetailGallery
